import OrderCartBox from '@components/order/components/order-cart/web/OrderCartBox';
import useDevice from '@hooks/useDevice';
import { useRootStore } from '@hooks/useRootStore';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import FoodCategoryDrawer from '../components/food-category/mobile/FoodCategoryDrawer';
import FoodCategoryMenu from '../components/food-category/web/FoodCategoryMenu';
import FoodList from '../components/food/FoodList';
import RestaurantDetails from '../components/restaurant/details/RestaurantDetails';

interface RestaurantOfferPageProps {
}

const RestaurantOfferPage: React.FC<RestaurantOfferPageProps> = observer(({ }) => {
    const { restaurantOfferStore } = useRootStore();
    const { onRestaurantOfferPageMount, onRestaurantOfferPageUnmount } = restaurantOfferStore;

    const { isMobileDevice, isWebDevice, isTablet } = useDevice();

    let params = useParams();

    useEffect(() => {
        var restaurantId = params.restaurantId;
        if (restaurantId !== undefined) {
            onRestaurantOfferPageMount(restaurantId);
        }

        window.scrollTo({ top: 0, behavior: "smooth" })
        return () => {
            onRestaurantOfferPageUnmount();
         }
    }, []);

    return (
        <Box>
            <RestaurantDetails restaurantOfferStore={restaurantOfferStore} />

            <Box display={"flex"} flexDirection={"row"} mt={{ xs: 2, sm: 4, md: 6 }}>
                {(isWebDevice || isTablet) && <FoodCategoryMenu restaurantOfferStore={restaurantOfferStore} />}
                <FoodList restaurantOfferStore={restaurantOfferStore} />
                {isWebDevice && <OrderCartBox />}
            </Box>

            {isMobileDevice && <FoodCategoryDrawer restaurantOfferStore={restaurantOfferStore} />}
        </Box>
    )
})

export default RestaurantOfferPage;